import ParameterErrors from '../errors/ParameterErrors';
import PlotStatusConfiguration from './PlotStatusConfiguration';
import PlotStatus from '../site/PlotStatus';
const {throwNotProvided}=ParameterErrors;
export default class PlotStatusConfigurations{
	constructor(props){
		const {list}=props;
		this._list = list;
		this.getFromPlotStatus = this.getFromPlotStatus.bind(this);
		this.toCssHtmlString = this.toCssHtmlString.bind(this);
	}
	getFromPlotStatus(plotStatus){
		for(var i=0; i<this._list.length; i++){
			const plotStatusConfiguration = this._list[i];
			if(plotStatusConfiguration.plotStatus===plotStatus)
				return plotStatusConfiguration;
		}
		return null;
	}
	toCssHtmlString(){
		let strs=[':root {'];
		for(var i=0; i<this._list.length; i++){
			const plotStatusConfiguration = this._list[i];
			const cssNamePrefix = PlotStatus.getCssName(plotStatusConfiguration.plotStatus);
			strs.push(`--${cssNamePrefix}${PlotStatusConfiguration.UNIT_MARKER_COLOR_SUFFIX}:${plotStatusConfiguration.unitMarkerColor};`);
		}
		strs.push('}');
		
		return strs.join('\n');
	}
	static fromJSON(jObject){
		const plotStatusConfigurations = [];
		for(var key in jObject){
			const plotStatus = PlotStatus.parse(key);
			plotStatusConfigurations.push(PlotStatusConfiguration.fromEnumAndJObject(plotStatus, jObject[key]));
		}
		return new PlotStatusConfigurations({list:plotStatusConfigurations});
	}
}